<template>
  <section>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('addEditCommande.lieuLivraison.title') }}</p>
      </header>
      <div class="card-content">
        <v-client-table
          v-if="lignesByLieux.length"
          :data="lignesByLieux"
          :columns="columns"
          :options="options"
          class="tableWithChildRow displayNonePagination">
          <template #libelleLieu="{ row }">
            {{ getLibelleLieu(row) }}
          </template>
          <template #quantite="{ row }">
            <div class="is-pulled-right">
              {{ getSumLignes(row, 'quantite') }}
            </div>
          </template>
          <template #quantiteReceptionnee="{ row }">
            <div class="is-pulled-right">
              {{ getSumLignes(row, 'quantite') - getSumLignes(row, 'quantiteResteARapprocher') }}
            </div>
          </template>
          <template #solde="{ row }">
            <div class="is-pulled-right">
              {{ getSumLignes(row, 'quantiteResteARapprocher') }}
            </div>
          </template>
          <template #child_row="{ row }">
            <lieu-de-livraison-tab-child-row :lignes="row.lignes" />
          </template>
        </v-client-table>
      </div>
    </div>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import * as tableConfig from '@/configuration/clientTableConf';
import lieuDeLivraisonTabChildRow from './lieuDeLivraisonTabChildRow';

export default {
  components: {
    lieuDeLivraisonTabChildRow,
  },
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    lignesByLieux() {
      const lieux = this.commande.lignesCommande.map(ligne => {
        return ligne.lieuxLivraisons.map(ll => {
          return {
            ...ll,
            libelle: ligne.libelle,
          };
        });
      }).flat(2);

      const lignesGrouped = Object.groupBy(lieux, (l) => l.lieuDeLivraisonId);
      return Object.keys(lignesGrouped).map(id => {
        return {
          id: id,
          lignes: lignesGrouped[id],
        };
      });
    },
    columns() {
      return ['libelleLieu', 'quantite', 'quantiteReceptionnee', 'solde'];
    },
    options() {
      const texts = cloneDeep(tableConfig.TEXTS);
      texts.count = '';
      return {
        texts,
        headings: {
          libelleLieu: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.lieuLivraison'),
          quantite: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.quantiteCommandee'),
          quantiteReceptionnee: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.quantiteReceptionnee'),
          solde: this.$t('detailCommandeAchatFournisseur.lieuLivraison.table.solde'),
        },
        filterable: false,
        sortIcon: tableConfig.SORT_ICON,
        perPage: tableConfig.RESULTS_PER_PAGE,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        sortable: [],
        columnsClasses: {
          quantite: 'colonneWith180',
          quantiteReceptionnee: 'colonneWith180',
          solde: 'colonneSelected',
        },
      };
    },
  },
  methods: {
    getSumLignes(row, field) {
      return row.lignes.reduce((a, l) => a + l[field], 0);
    },
    getLibelleLieu(row) {
      return row.lignes[0]?.lieuDeLivraison?.nomCommercial ?? '';
    },
  },
};
</script>

<style>
</style>
